import clsx from "clsx";
import { useState } from "react";
import { useRevalidator } from "react-router";

import AssignmentApi from "@/api/assignment-api";
import Star from "@/components/star";
import { logRejection } from "@/helpers";

interface StarRatingProps {
  size?: number;
  score?: number;
  max_score?: number;
  // onScoreChanged?: (score: number) => void;
  candidate_id: string;
}

export default function StarRating({
  size = 4,
  score = 0,
  max_score = 3,
  candidate_id,
  // onScoreChanged,
}: StarRatingProps) {
  const revalidator = useRevalidator();
  const [score_under_mouse, setScoreUnderMouse] = useState(0);

  const _mouseEnter = (star_score: number, star_ref: React.RefObject<HTMLButtonElement | null>) => {
    star_ref.current?.classList.remove("star-rating-jump");
    setScoreUnderMouse(star_score);
  };

  const _mouseLeave = () => {
    setScoreUnderMouse(0);
  };

  const _mouseDown = (star_score: number, star_ref: React.RefObject<HTMLButtonElement | null>) => {
    setScoreUnderMouse(0);
    star_ref.current?.classList.add("star-rating-jump");
    // onScoreChanged && onScoreChanged(star_score);
    onRating(star_score);
  };

  const onRating = (new_score: number) => {
    const abort_controller = new AbortController();
    AssignmentApi.rateCandidate(candidate_id, new_score, abort_controller.signal)
      .then(({ error }) => {
        if (error) {
          console.error(error);
        } else {
          void revalidator.revalidate();
        }
      })
      .catch(logRejection);
  };

  const stars_class = clsx("flex", "cursor-pointer");

  return (
    <div className={stars_class} onMouseLeave={_mouseLeave}>
      {[...Array(max_score)].map((_, i) => {
        return (
          <Star
            key={i}
            size={size}
            filled={score - i}
            under_mouse_score={score_under_mouse - i}
            value={i + 1}
            mouseEnter={_mouseEnter}
            onClick={_mouseDown}
          />
        );
      })}
    </div>
  );
}
